import { render } from "./UnitTranslationTable.vue?vue&type=template&id=09c7cbda&scoped=true"
import script from "./UnitTranslationTable.vue?vue&type=script&lang=js"
export * from "./UnitTranslationTable.vue?vue&type=script&lang=js"

import "./UnitTranslationTable.vue?vue&type=style&index=0&id=09c7cbda&lang=css"
import "./UnitTranslationTable.vue?vue&type=style&index=1&id=09c7cbda&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c7cbda"]])

export default __exports__